
import React, { useEffect, useState } from 'react';
import './index.css';
import { Col, Row, } from 'antd';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import LoginSelector from 'views/login/login.selector';
import { convertToLocalString, getQueryParamsFromString } from '__utils/common-utils';
import { useDeepCompare } from '../../hooks/use-deep-memo';


import FolioCards from './folio-cards';
import FolioOperations from './folio-operations';
import moment from 'moment';
import { LayoutContext } from 'components/app-routes';


const PortfolioDetails: React.FC = () => {
    const { folioNo,schemeId } = getQueryParamsFromString(window.location.search);
    const [folioData, setFolioData] = useState<any>();
    const { portfolioDetails } = propsToJS(useSelector(LoginSelector));
    const { SetLayoutProps } = React.useContext(LayoutContext);

    useEffect(() => {
        SetLayoutProps({
            config: {
                title: 'Transaction History',
            }
        });
    }, [])
    
    useEffect(() => {
        (folioNo && portfolioDetails) && setFolioData(portfolioDetails.portfolioSchemes?.filter((scheme: any) => scheme?.folioNo === folioNo && scheme?.metaData?.schemeId === schemeId)[0])
    }, [folioNo,useDeepCompare(portfolioDetails)])

    return (

        <div>
            {
                folioData && <div>
                    <FolioCards portfolioScheme={folioData} showDetail={false} />
                    { (folioData?.metaData?.fundType === 'Open Ended Investment Company' && !(folioData?.setupDate > new Date())) && <FolioOperations portfolioRecord={folioData} />}
                    {
                        folioData?.portfolioSchemeTransactions.map((transaction: any, index: number) => (
                            <div className='folio-card portfolioDetailText' key={index}>
                                <Row gutter={16} justify='space-between'>
                                    {/* <Col xs={5}>
                                        <img src={require(`images/${transaction.transactionType}_${transaction.type}.svg`)} width='100%'/>
                                    </Col> */}
                                    <Col xs={12}>
                                        {/* <p className='detail-title'>{transaction.transactionType}</p> */}
                                        <p>Folio : <span>{transaction.folioNo}</span></p>
                                        <p>{moment(transaction?.transactionDate).format('DD/MM/YYYY')} </p>
                                    </Col>
                                    <Col xs={6}>
                                        {/* <p className='detail-title'><strong>{transaction?.type == 'Redemption' ? '-' : '+'}{convertToLocalString(transaction?.amount)}</strong></p>
                                        <p>Units: {transaction?.type == 'Redemption' ? '-' : '+'}{transaction?.units?.toFixed(2)}</p> */}
                                        <p className='detail-title'><strong>{transaction?.type == 'S' ? '-' : '+'}{convertToLocalString(transaction?.amount)}</strong></p>
                                        <p>Units: {transaction?.type == 'S' ? '-' : '+'}{transaction?.units?.toFixed(2)}</p>
                                        <p>Nav : <span>{transaction?.nav?.toFixed(2)}</span></p>
                                    </Col>
                                </Row>
                            </div>
                        ))
                    }
                </div>

            }

        </div>
    )
}
export default PortfolioDetails;

